import React from 'react'
import { Link } from 'react-router'
import { Row } from 'reactstrap';

import ProfileStatus from './profile/ProfileStatus'
import ProfileButton from './profile/ProfileButton'
import ProfileInfo from './profile/ProfileInfo'
import ProfileSkills from './profile/ProfileSkills'
import ProfileEquipments from './profile/ProfileEquipments'
import ProfileDocuments from './profile/ProfileDocuments'
//import ProfileContacts from './profile/ProfileContacts'

import Loader from '../../core/components/Loader'

import '../styles/style.css';
import '../styles/profile.css';

class Provider extends React.Component {

	constructor(props) {
        super(props);
        this.state = {
            responsive:false
        };
    }

    componentDidMount() {
      this.props.retrieveProvider(this.props.provider_id);
      this.props.listSpecialties();
      this.props.listEquipments();
      if( window.innerWidth < 520)
        this.setState({responsive:true})
    }

    renderProfile(){
        const { provider } = this.props.provider;
        const { specialties, equipments, user } = this.props;
        const statusProviderBlocked = ['W', 'R', 'RV', 'A']

        return (
            <div className="provider-profile">

                <Row>
                    {!this.state.responsive &&
                        <ProfileStatus user={user} provider={provider} responsive={this.state.responsive}/>
                    }
                    {!this.state.responsive &&
                        (!statusProviderBlocked.includes(provider.status) || user.role === 'manager' || user.role === 'superadmin') &&
                        <ProfileButton user={user} provider={provider} responsive={this.state.responsive}/>
                    }
                </Row>

                <Row>
                    {this.state.responsive &&
                        (!statusProviderBlocked.includes(provider.status) || user.role === 'manager' || user.role === 'superadmin') &&
                        <ProfileButton user={user} provider={provider} responsive={this.state.responsive}/>
                    }
                    {this.state.responsive &&
                        <ProfileStatus user={user} provider={provider} responsive={this.state.responsive}/>
                    }
                </Row>

                {/*{!this.state.responsive &&*/}
                    {/*<Row>*/}
                        {/*<ProfileStatus user={user} provider={provider} responsive={this.state.responsive}/>*/}
                        {/*<ProfileButton user={user} provider={provider} responsive={this.state.responsive}/>*/}
                    {/*</Row>*/}
                {/*}*/}
                {/*{this.state.responsive &&*/}
                    {/*<Row>*/}
                        {/*<ProfileButton user={user} provider={provider} responsive={this.state.responsive}/>*/}
                        {/*<ProfileStatus user={user} provider={provider} responsive={this.state.responsive}/>*/}
                    {/*</Row>*/}
                {/*}*/}

                <ProfileInfo provider={provider} responsive={this.state.responsive}/>

                <div className="provider-profile-bloc">
                    <ProfileSkills provider={provider} specialties={specialties} responsive={this.state.responsive}/>
                    <ProfileEquipments provider={provider} equipments={equipments} responsive={this.state.responsive}/>
                </div>

                <ProfileDocuments provider={provider} />

                {/* <ProfileContacts provider={provider} responsive={this.state.responsive}/> */}

            </div>
        )
    }

    render() {
    	const { provider, user } = this.props

    	return (
            <div className="provider-bloc">

                {provider.pending &&
                    <Loader />
                }

                {provider.provider &&
                    this.renderProfile()
                }

            </div>
        )
    }
}

export default Provider



// WEBPACK FOOTER //
// ./src/provider/components/Provider.js